import { FC } from "react";
import useEvent from "react-use-event-hook";

import { IExtendableDto, SimpleResult } from "@ryde/shared";

import { CalendarBookingRideIdLinkStyled } from "./booking-calendar.styled";

export const RideIdLink: FC<{
  id: number;
  openRideEditFormDrawer: (p: {
    id?: number;
  }) => Promise<SimpleResult<IExtendableDto>>;
}> = ({ id, openRideEditFormDrawer }) => {
  const onClick = useEvent((): void => {
    openRideEditFormDrawer({ id });
  });
  return (
    <CalendarBookingRideIdLinkStyled>
      <span
        onClick={onClick}
        className="calendar-booking-ride-id-link-clickable"
      >
        {id}
      </span>
    </CalendarBookingRideIdLinkStyled>
  );
};
